{
    "receive.heading" : "Al",
    "receive.description" : "Bu sayfa, alma sürecindeki durum, döngü ve konteyner ile paket sayılarını gösterir",
    "receive.filter.title" : "Seçenekler",
    "receive.filter.cycle" : "Döngü",
    "status.current_planned" : "Mevcut Planlanan",
    "status.planned_inducted" : "Mevcut Girilmiş Gerçek",
    "status.unplanned_inducted" : "Diğer/Planlanmamış Kabul Edilen Gerçek",
    "CPT." : "CPT",
    "CPT.cpt" : "CPT",
    "CPT.induct_by" : "İşlem yapan",
    "CPT.stow_by" : "İstifleme kriteri",
    "receive.overall_status" : "Genel Durum",
    "receive.packages" : "Paketler",
    "receive.predicted_dispatch" : "Tahmini Sevkiyat (LMCP)",
    "receive.total_manifested" : "Toplam manifesto edilen",
    "receive.container_planned_volume" : "Konteyner planlanan hacmi",
    "receive.current_cycle_planned" : "Mevcut Döngüde Planlanan",
    "receive.current_cycle_actual" : "Mevcut Döngüde Gerçekten Teslim Alınanlar",
    "receive.other_cycles" : "Diğer/Planlanmamış Döngüde Gelen Gerçek",
    "receive.current_planned" : "Mevcut Planlanan",
    "receive.current_actual" : "Mevcut Gelen Gerçek",
    "receive.other" : "Diğer/Planlanmamış Gelen Gerçek",
    "receive.total" : "Gerçek Toplam Gelen",
    "status.planned_inducted_cycle" : "Mevcut Döngüde Kabul Edilen Gerçek",
    "status.unplanned_inducted_cycle" : "Diğer/Planlanmamış Döngüde Kabul Edilen Gerçek",
    "status.current_cycle_planned" : "Mevcut Döngüde Planlanan",
    "status.total_inducted" : "Toplam Girilmiş Gerçek",
    "receive.current_status" : "Geçerli durum",
    "receive.manifested" : "Bildirildi",
    "receive.manifested.unplanned" : "Planlanmamış Manifesto Edilen",
    "receive.in_transit" : "Taşınıyor",
    "receive.in_transit.unplanned" : "Taşınma Halinde Planlanmamış",
    "receive.arrived" : "Ulaştı",
    "receive.arrived.unplanned" : "Planlanmamış Gelen",
    "receive.marked_for_reprocess" : "Yeniden işleme için işaretlendi",
    "receive.marked_for_reprocess.unplanned" : "Yeniden İşleme için Planlanmamış İşaretlendi",
    "receive.inducted" : "İndüklenen",
    "receive.stow_buffered" : "İstiflenmiş tamponlu",
    "receive.stowed" : "İstiflendi",
    "receive.sidelined" : "Kenara alındı",
    "receive.group_by" : "Gruplandırma ölçütü:",
    "linehaul.linehauls" : "Hat Taşımaları",
    "linehaul.status" : "Durum",
    "linehaul.arrival" : "Geliş",
    "linehaul.details" : "Detaylar",
    "linehaul.vrid" : "VRID",
    "linehaul.origin" : "Menşe",
    "linehaul.location" : "Konum",
    "linehaul.planned" : "Planlanan",
    "linehaul.actual" : "Gerçek",
    "linehaul.volume" : "Hacim",
    "linehaul.FMC" : "FMC",
    "linehaul.unloadSequence" : "Boşaltma Sırası",
    "linehaul.inyard" : "Avluda",
    "linehaul.arrived" : "Ulaştı",
    "linehaul.incoming" : "Gelen",
    "linehaul_detail.receive" : "Al",
    "linehaul_detail.linehaul_details" : "Hat Taşıma Detayları",
    "linehaul_detail.linehaul" : "Linehaul ",
    "linehaul_detail.from" : "Başlangıç tarihi",
    "linehaul_detail.departed" : "Ayrıldı",
    "linehaul_detail.arrived" : "Ulaştı",
    "linehaul_detail.options" : "Seçenekler",
    "linehaul_detail.id" : "Kimlik",
    "linehaul_detail.type" : "Tür",
    "linehaul_detail.pending_induct" : "Bekleyen Başvuru ",
    "linehaul_detail.total" : "Toplam ",
    "linehaul_filter.packagesize" : "Paket Boyutu",
    "linehaul_filter.ead" : "İstasyon EAD",
    "linehaul_filter.cycle" : "Döngü",
    "linehaul_filter.cluster" : "Küme",
    "linehaul_filter.unplanned" : "Planlanmamış",
    "linehaul_filter.sideline" : "Kenar",
    "linehaul_filter.commercial" : "Ticari",
    "linehaul_filter.cosmos" : "Evren",
    "linehaul_filter.clear_all" : "Tümünü temizle",
    "receivergroup.none" : "Hiçbiri",
    "receivergroup.package_size" : "Paket Boyutu",
    "receivergroup.station_ead" : "İstasyon EAD",
    "receivergroup.cluster" : "Küme",
    "receivergroup.cycle" : "Döngü",
    "linehaul_filter.otherattributes" : "Diğer özellikler",
    "induct.heading" : "İndükleyin",
    "induct.description" : "Bu sayfa kabul sürecindeki durum, döngü, konteyner ve paket sayılarını gösterir",
    "induct.induct" : "İndükleyin",
    "induct.induct_area" : "Kabul Alanları",
    "induct.induct_type" : "Kabul Türü",
    "induct.manual" : "Manuel",
    "induct.automated" : "Otomatik",
    "induct.active_associate" : "Aktif ortaklar",
    "induct.induct_rate" : "Kabul Hızı",
    "induct.total_inducted" : "Toplam Kabul Edilen",
    "induct.container" : "Konteyner",
    "induct.container_id" : "Kimlik",
    "induct.type" : "Tür",
    "induct.pending_induct" : "Bekleyen Başvuru ",
    "induct.total" : " Toplam",
    "induct.aslInductArea" : "ASL Giriş Alanı",
    "induct.max_induct_rate" : "Maksimum Kabul Hızı",
    "induct.station_percentage" : "İstasyonun yüzdesi",
    "induct.successful_percentage" : "% Başarılı",
    "induct.kickout" : "Kickout",
    "induct.noread" : "Okuma yok",
    "induct.timeout" : "Zaman aşımı",
    "induct.failed_verification" : "Doğrulama Başarısız",
    "induct.sidelined" : "Kenara alındı",
    "induct.cycle" : "Döngü",
    "induct.unplanned" : "Planlanmamış",
    "associate.heading" : "Ortakları işe alın",
    "associate.description" : "Bu sayfa kabul personelinin performans verilerini ve mevcut çalışma konumlarını gösterir",
    "associate.yes" : "Evet",
    "associate.no" : "Hayır",
    "associate.option" : "Seçenekler",
    "associate.active" : "Aktif",
    "associate.associates" : "Ortaklar",
    "associate.associate" : "Bağdaştırma",
    "associate.pph" : "PPH",
    "associate.hours" : "Saat",
    "associate.total_packages" : "Toplam Paket Sayısı",
    "associate.location" : "Konum",
    "associate.inactive_period" : "Pasif Süre",
    "package.package_summary" : "Paket özeti",
    "package.tracking_id" : "Takip Numarası",
    "package.last_scan_date_time" : "Son Tarama",
    "package.minutes_in_state" : "Durumdaki dakika miktarı",
    "package.package_state" : "Durum",
    "package.package_reason" : "Neden",
    "package.location" : "Konum",
    "package.cycle" : "Döngü",
    "package.cpt" : "CPT",
    "package.sort_zone" : "Sıralama bölgesi",
    "package.cluster" : "Küme",
    "package.EAD" : "İstasyon EAD",
    "package.size" : "Boyut",
    "package.station_code" : "Hedef",
    "package.package_list" : "Paket Listesi",
    "package.download" : "İndir",
    "induct.error" : "Bir hata oluştu",
    "tooltip.predicated_lmcp" : "LMCP tahmin hacmi",
    "tooltip.current_planned" : "Sıralama planlayıcı (RTW) tarafından manifesto edilen nakliyeler",
    "tooltip.planned_inducted" : "Planlanan nakliyeler: varmış VEYA kabul edilmiş VEYA yeniden kabul bekliyor",
    "tooltip.unplanned_inducted" : "İstasyona ulaşan diğer nakliyeler",
    "tooltip.manifested" : "Bu zaman dilimi için planlanan ve teslimat istasyonuna yönlendirilmiş kamyona manifesto edilmiş nakliyeler",
    "tooltip.unplanned_manifested" : "Bu zaman dilimi için planlanmayan ve teslimat istasyonuna yönlendirilmiş kamyona manifesto edilmiş nakliyeler",
    "tooltip.in_transit" : "Bu zaman dilimi için planlanan ve teslimat istasyonuna giden kamyonda olan nakliyeler",
    "tooltip.unplanned_in_transit" : "Teslimat istasyonuna doğru yolda olan kamyondaki, bu zaman dilimi için planlanmamış nakliyeler",
    "tooltip.arrived" : "Bu zaman dilimi için planlanan ve teslimat istasyonuna ulaşan nakliyeler",
    "tooltip.unplanned_arrived" : "Teslimat istasyonuna ulaşan bu süre için planlanmamış nakliyeler",
    "tooltip.marked_for_reprocess" : "Fixit üzerinden çözülen bu süre için planlanmış olan nakliyeler",
    "tooltip.unplanned_marked_for_reprocess" : "Fixit üzerinden çözülen bu süre için planlanmamış nakliyeler",
    "tooltip.inducted" : "Bu paket durumunda olan ve bu sürede başarıyla kabul edilen nakliyeler",
    "tooltip.stowed" : "Şu anda bu paket durumunda olan ve bu süre içinde başarıyla istiflenmiş olan nakliyeler",
    "tooltip.sidelined" : "Bu süre zarfında giriş aşamasında kenara alınmış ve şu anda Bekletiliyor (Kenara Alındı) durumunda olan paketler",
    "tooltip.current_cycle_planned" : "Sıralama planlayıcı (RTW) tarafından manifesto edilen nakliyeler",
    "tooltip.planned_cycle_inducted" : "Planlanan nakliyeler: varmış VEYA kabul edilmiş VEYA yeniden kabul bekliyor",
    "tooltip.unplanned_cycle_inducted" : "İstasyona ulaşan diğer nakliyeler",
    "tooltip.total_inducted_cycle" : "Mevcut Döngü Gelen ile Diğer/Planlanmamış Gelen Gerçek Toplamı",
    "tooltip.current_arrived" : "Planlanan nakliyeler: varmış VEYA kabul edilmiş VEYA yeniden kabul bekliyor",
    "tooltip.other_unplanned_arrived_actual" : "İstasyona ulaşan diğer nakliyeler",
    "tooltip.current_cycle_arrived" : "Planlanan nakliyeler: varmış VEYA kabul edilmiş VEYA yeniden kabul bekliyor",
    "tooltip.other_unplanned_cycle_arrived_actual" : "İstasyona ulaşan diğer nakliyeler",
    "tooltip.total_arrived_actual_cycle" : "Mevcut Döngü Gelen ile Diğer/Planlanmamış Gelen Gerçek Toplamı",
    "tooltip.manifested_cycle" : "Teslimat istasyonuna gitmesi planlanan bir kamyona yüklenmiş ve bu döngü kapsamında planlanmış gönderiler",
    "tooltip.unplanned_manifested_cycle" : "Teslimat istasyonuna gitmesi planlanmayan bir kamyona manifesto edilmiş ve bu döngü kapsamında planlanmış gönderiler",
    "tooltip.in_transit_cycle" : "Bu döngü için planlanan ve teslimat istasyonuna giden kamyonda olan sevkiyatlar",
    "tooltip.unplanned_in_transit_cycle" : "Bu döngü için planlanmayan ancak teslimat istasyonuna giden kamyonda bulunan nakliyeler",
    "tooltip.arrived_cycle" : "Teslimat istasyonuna ulaşan bu döngü için planlanan nakliyeler",
    "tooltip.unplanned_arrived_cycle" : "Teslimat istasyonuna ulaşan bu döngü için planlanmamış nakliyeler",
    "tooltip.marked_for_reprocess_cycle" : "Fixit üzerinden çözülen bu döngü için planlanmış olan nakliyeler",
    "tooltip.unplanned_marked_for_reprocess_cycle" : "Fixit üzerinden çözülen bu döngü için planlanmamış nakliyeler",
    "tooltip.inducted_cycle" : "Bu paket durumunda olan ve bu döngüde başarıyla kabul edilen nakliyeler",
    "tooltip.stowbuffered_cycle" : "Şu anda bu paket durumunda olan ve bu döngü sırasında başarıyla ara depolamaya alınmış gönderiler",
    "tooltip.stowed_cycle" : "Şu anda bu paket durumunda olan ve bu döngü sırasında başarıyla istiflenmiş olan nakliyeler",
    "tooltip.sidelined_cycle" : "Bu döngü sırasında giriş aşamasında kenara alınmış ve şu anda Bekletiliyor (Kenara Alındı) durumunda olan paketler",
    "tooltip.total_arrived_actual" : "Mevcut Gelen ile Diğer/Planlanmamış Gelen Gerçek Toplamı",
    "tooltip.max_induct_rate" : "ASL makinesi için beklenen maksimum indüksiyon oranı.",
    "tooltip.induct_rate" : "Saat başına ortalama kabul edilen paket sayısı.",
    "tooltip.total_inducted" : "Mevcut vardiyada indüklenen toplam paket sayısı.",
    "tooltip.station_percentage" : "ASL makinesi ile girişe alınan paketlerin, toplam istasyon hacmine oranı (yüzde olarak).",
    "tooltip.successful_percentage" : "ASL makinesi tarafından başarıyla taranan paketlerin yüzdesi.",
    "tooltip.non_conveyable_description" : "NC: Tek boyutta 106,68 cm’yi aşan paketler. \n FCLM, NC için farklı boyut kriterlerine sahip olabilir",
    "tooltip.kickout" : "ASL kabulü sırasında dışlanan paket sayısı.",
    "tooltip.noread" : "Giriş kamerası tarafından geçerli bir barkodu okunamayan, ASL tarafından işlenmiş paket sayısı.",
    "tooltip.timeout" : "SLA içinde kabul yanıtı almayan ASL tarafından işlenen paket taramalarının sayısı.",
    "tooltip.failed_verification" : "ASL tarafından işlenen ve çıkış kamerası tarafından doğrulanmayan paket sayısı.",
    "generic.error" : "Bir hata oluştu",
    "generic.close" : "Kapat",
    "generic.enabled" : "Etkin",
    "generic.disabled" : "Devre dışı",

    "header.induct_management" : "Kabul Yönetimi",

    "induct_management.induct_setup" : "Kabul Kurulumu",
    "induct_management.select_cycle" : "Döngü Seç",
    "induct_management.current_sort_cycle" : "Mevcut Sıralama Döngüsü",
    "induct_management.current_cycle_state" : "Mevcut Döngü Durumu",
    "induct_management.current_force_induct_status" : "Mevcut Zorla Kabul Durumu",
    "induct_management.enable_force_induct" : "Zorla Kabul Etmeyi Etkinleştirin",
    "induct_management.sort_cycle" : "Sıralama Döngüsü",
    "induct_management.force_induct_sort_cycle" : "Mevcut sıralama döngüsündeki tüm gelen paketleri zorla kabul edin",
    "induct_management.start_sort_cycle" : "Kabulü Başlatın",
    "induct_management.container_plan_failure" : "Konteyner planı alınırken hata oluştu. Lütfen daha sonra tekrar deneyin",
    "induct_management.mapped_cycles_failure" : "Aktif döngüler alınırken hata oluştu. Lütfen daha sonra tekrar deneyin",
    "induct_management.set_node_operational_failure" : "Kabul döngüsü kaydedilirken hata oluştu. Lütfen daha sonra yeniden deneyin",
    "induct_management.get_node_operational_failure" : "Geçerli Sıralama Döngüsü Bilgilerini alırken bir hata oluştu. Lütfen daha sonra yeniden deneyin",
    "induct_management.non_mco_station" : "Bu sayfa henüz istasyonunuz için etkin değil. İstasyonunuz çok döngülü işlemleri destekliyorsa daha fazla güncelleme için bizi izlemeye devam edin :-)",
    "induct_management.bad_request" : "Lütfen açılır listeden doğru döngüyü seçin",
    "induct_management.set_node_induct_process_details_success" : "Kabul döngüsü başarıyla başlatıldı",
    "induct_management.no_active_container_plans_available" : "Bu istasyon için yapılandırılmış aktif konteyner planı yok, lütfen daha sonra tekrar deneyin",
    "induct_management.pick_started_for_the_current_cycle" : "Mevcut döngü için toplama işlemi başlatıldı, bu nedenle indüksiyon engellendi ",
    "induct_management.start_induct" : ". Lütfen doğru döngüye geçin ve kabul işlemini başlatın.",
    "common.data_last_updated" : "Veriler son güncellendi",
    "inductmanagement.heading" : "Kabul döngüsü yönetimi",
    "inductmanagement.description" : "Bu sayfa, indüksiyon döngüsü ayarlarını değiştirmenize izin verir",
    "inductmanagement.manage_cycle" : "Döngüleri yönetme",
    "inductmanagement.force_induct" : "Zorla kabul etme",
    "inductmanagement.active_until" : "Etkin Olana Kadar",
    "inductmanagement.noCycles" : "Döngü mevcut değil",
    "inductmanagement.disableCycle" : "Döngüyü devre dışı bırakın",
    "inductmanagement.enableCycle" : "Döngüyü etkinleştir",
    "inductmanagement.enterCycle" : "Döngüyü Girin...",
    "inductmanagement.enterStationCode" : "İstasyon Kodu Girin...",
    "inductmanagement.noStations" : "Kullanılabilir istasyon yok",
    "inductmanagement.selectStatus" : "Durumu Seç...",
    "inductmanagement.enableForceInduct" : "Zorla kabulü etkinleştirin",
    "inductmanagement.disableForceInduct" : "Zorunlu indüksiyonu devre dışı bırak",
    "inductmanagement.activateSortToRouteError" : "Başka bir SORT_TO_ROUTE türü döngü etkinleştirilemiyor. {cycle} zaten aktif.",
    "inductmanagement.activateCycleError" : "Döngü etkinleştirilirken hata oluştu: {cycle}",
    "inductmanagement.deactivateCycleError" : "Döngüyü devre dışı bırakırken bir hatayla karşılaşıldı: {cycle}",
    "inductmanagement.unselectedWarning" : "Lütfen etkinleştirmeyi tıklamadan önce bir düğüm ve döngü seçin",
    "inductmanagement.setForceError" : "Döngü için zorla kabul güncellenirken hata oluştu: {cycleName}",
    "inductmanagement.deliveryWindowConfiguration" : "Teslimat zaman aralığı yapılandırması",
    "inductmanagement.dynamicCPlan" : "Dinamik C.Plan",
    "tooltip.dynamicCPlan" : "Mobius iş akışında DRS döngüleri için konteyner planlama durumu. Hazır: En son konteyner planı hazır, kabul işlemi başlatılabilir. Hazır Değil: En son konteyner planı hazır değil, kabul işlemi başlatılamaz. Başarısız Eksik Planlama: Daha az sıralama bölgesi yapılandırıldığı için başarısız.",
    "inductmanagement.getConfigFail" : "Paket döngü yapılandırması alınırken bir hatayla karşılaşıldı",
    "inductmanagement.setConfigFail" : "Paket döngü yapılandırması ayarlanırken bir hatayla karşılaşıldı",
    "inductmanagement.parallelNotEnabled" : "Paralel kabul sekmesi istasyonunuz için etkinleştirilmemiş",
    "inductmanagement.notEnabled" : "Zamanlanmış teslimat aralığı yapılandırma sekmesi istasyonunuz için etkinleştirilmemiş",
    "inductmanagement.saveSuccess" : "Yapılandırma değişikliği başarıyla gönderildi. Değişikliklerin gelen planlı teslimat paketleri için geçerli olması 60 dakika kadar sürebilir",
    "inductmanagement.noWindowsConfigured" : "Zamanlanmış teslimat aralıkları yapılandırılmamış. Yeni zaman aralıkları eklemek için düzenle’ye basın",
    "inductmanagement.start" : "Başla",
    "inductmanagement.end" : "Sonlandır",
    "inductmanagement.addNewWindow" : "Yeni pencere ekle",
    "inductmanagement.deliveryWindow" : "Teslimat Aralığı",
    "inductmanagement.cycles" : "Döngüleri",
    "inductmanagement.save" : "Kaydet",
    "inductmanagement.edit" : "Düzenle",
    "inductmanagement.submit" : "G?nder",
    "inductconfig.noActiveLanes": "Tüm şeritler etkin değil veya bekletme şeritleridir, palet veya arabalar için şerit kalmadı.",
  "inductconfig.noCartLanes": "Tüm şeritler etkin değil, bekletme veya palet şeritleridir. Arabalar için şerit kalmadı.",
    "inductconfig.noBeltsConfigured": "Yapılandırılmış indüksiyon bandı yok. Lütfen en az bir bant ekleyin.",
    "inductconfig.holdLaneWarning": "Bekletme şeridi yapılandırılmadı. Bu döngü sırasında konteynerler tutulamaz. Devam etmek istiyor musunuz?",
    "inductconfig.singleBeltWarning": "Yalnızca bir aktif bant yapılandırıldı. Bu bant arızalanırsa hiçbir paket indüklenemez. Devam etmek istiyor musunuz?",
    "inductconfig.inactiveHoldOverlap": "Etkin olmayan şerit(ler) {lanes} aynı zamanda bekletme şeritlerinde olamaz.",
    "inductconfig.inactivePalletOverlap": "Etkin olmayan şerit(ler) {lanes} aynı zamanda palet şeritlerinde olamaz.",
    "inductconfig.palletLanes": "Palet Şeritleri",
    "inductconfig.priorityLaneCount": "Öncelikli Şerit Sayısı",
    "inductconfig.priorityLaneCountHint": "Öncelikli şerit sayısını girin (örn. 25)",
  "inductconfig.beltNoContainerTypes": "Bir veya daha fazla bantta konteyner tipi seçilmemiş. Her bant için en az bir konteyner tipi seçin.",
  "inductconfig.beltNoCubeTypes": "Bir veya daha fazla bantta küp tipi seçilmemiş. Her bant için en az bir küp tipi seçin.",
    "inductconfig.noActiveBelts": "Yapılandırılmış aktif indüksiyon bandı yok. Paketleri işlemek için en az bir bant aktif olmalıdır.",
  "inductconfig.containerTypeNotCovered": "Bir veya daha fazla konteyner tipi hiçbir aktif banda atanmamış. Tüm konteyner tipleri en az bir aktif bant tarafından karşılanmalıdır.",
  "inductconfig.cubeTypeNotCovered": "Bir veya daha fazla küp tipi hiçbir aktif banda atanmamış. Tüm küp tipleri en az bir aktif bant tarafından karşılanmalıdır.",
  "inductconfig.invalidLaneEntered": "Geçersiz şerit girildi. Lütfen geçerli bir şerit tanımlayıcı girin.",
  "inductconfig.selectCycleBeforeUpload": "Yüklemeyi gerçekleştirmeden önce lütfen bir döngü seçin.",
  "inductconfig.invalidCycleInCsv": "CSV dosyasında geçersiz veya eksik döngü. Lütfen geçerli bir döngü girin."
  }
